import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { UniversityItem } from '@tcaster/tcaster-web-lib';

import GridList from '../../Components/SearchableGridList';

export default class UniversityList extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
      }),
    ),
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: () => {},
  };

  constructor(props) {
    super(props);
  }

  handleClick = (id, index, data) => {
    this.props.onClick(id, data);
  };

  renderItem = (data, index) => {
    return <UniversityItem {...data} circleColor={data.color} onClick={() => {}} />;
  };

  render() {
    const { data, renderHeader } = this.props;
    return (
      <GridList
        data={data}
        renderItem={this.renderItem}
        onClick={this.handleClick}
        searchPlaceholderText="ใส่ชื่อมหาวิทยาลัย..."
        renderHeader={renderHeader}
        as="div"
      />
    );
  }
}
